export var LineType = /* @__PURE__ */ ((LineType2) => {
  LineType2["FUNCTION_DECLARATION"] = "function_declaration";
  LineType2["DEFINE"] = "define";
  LineType2["BODY"] = "body";
  return LineType2;
})(LineType || {});
